// extracted by mini-css-extract-plugin
export default {"container":"HowItWorks_container__cGM2J","loading":"HowItWorks_loading__sGegW"};